import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { TranslationService } from 'src/app/i18n/translation.service';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckboxComponent {
  @Input() customClass: string = '';
  lang: string = 'en';
  @Input() isErrorEnabled: boolean = false;
  @Input() data: any = {//remove it once you chane it everywhere
    title: 'SHOP.LIMITED_HOURS',
    name: 'limitedHours',
    value: false
  };
  @Output() onChange: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private translationService: TranslationService,
  ) {
    this.lang = this.translationService.getSelectedLanguage();
  }

  change() {
    this.onChange.emit(this.data.value);
  }

}
